<template>
  <div class="content">
    <RouterView v-if="isInit" />
    <LoadingIndex />
  </div>
</template>
<script lang="ts" setup>
import { useMainStore, useStore } from "@/store";
import useWx from "@/hooks/useWx";
import { watch } from "vue";
import { apiCheckwxuser } from "@/api";
import router from "@/router";
import { logout } from "@/hooks/useLogin";
import LoadingIndex from "@/components/loading/loadingIndex.vue";
import { getQueryVariable } from "@/utils";
const mainStore = useMainStore();
const store = useStore();
const { isInit, config } = useWx();
(async () => {
  try {
    store.setLoading(true);
    const { data } = await apiCheckwxuser({ corpId: getQueryVariable("corpId") as string });
    console.log(data);
    const { token } = data;
    if (token) store.setToken(token);
    if (data) store.setAddition(data);
    await config();
  } catch {
    logout();
  }
})();
watch(isInit, async (v) => {
  if (v) {
    await mainStore.setCustomer();
  }
});
</script>
<style lang="less" scoped>
.content {
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  overflow: hidden;
}
</style>
